export default __webpack_public_path__ + "static/media/baraka.642109f3.png";